import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import advanced from 'dayjs/plugin/advancedFormat';

dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(advanced);

export const getLoaclTimeZoneAndOffset = () => {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const abbr = dayjs().tz(userTimezone).format('z');
  const offset = new Date().getTimezoneOffset();

  const timezone =
    abbr +
    '/GMT' +
    (offset < 0 ? '+' + Math.abs(offset) / 60 : '-' + offset / 60);
  return { timezone, offset: -offset };
};
